import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img
              src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/c445464e9d5ab5582aee5503e8030d41.png"
              alt="IchiBan Marketing Digital"
              className="h-12 w-auto cursor-pointer"
              onClick={() => scrollToSection('home')}
            />
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors duration-300 hover:text-red-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Início
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors duration-300 hover:text-red-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('founders')}
              className={`font-medium transition-colors duration-300 hover:text-red-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Fundadores
            </button>
            <button
              onClick={() => scrollToSection('team')}
              className={`font-medium transition-colors duration-300 hover:text-red-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Time
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors duration-300 hover:text-red-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('partnerships')}
              className={`font-medium transition-colors duration-300 hover:text-red-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Amizades
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors duration-300 hover:text-red-600 whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Contato
            </button>
          </nav>

          <div className="hidden md:block">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-red-600 to-red-500 text-white px-6 py-2 rounded-full font-semibold hover:shadow-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Fale Conosco
            </button>
          </div>

          <button
            className="md:hidden p-2 cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl ${isScrolled ? 'text-gray-800' : 'text-white'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            <nav className="flex flex-col space-y-4 p-4">
              <button onClick={() => scrollToSection('home')} className="text-gray-800 font-medium hover:text-red-600 text-left whitespace-nowrap">
                Início
              </button>
              <button onClick={() => scrollToSection('about')} className="text-gray-800 font-medium hover:text-red-600 text-left whitespace-nowrap">
                Sobre
              </button>
              <button onClick={() => scrollToSection('founders')} className="text-gray-800 font-medium hover:text-red-600 text-left whitespace-nowrap">
                Fundadores
              </button>
              <button onClick={() => scrollToSection('team')} className="text-gray-800 font-medium hover:text-red-600 text-left whitespace-nowrap">
                Time
              </button>
              <button onClick={() => scrollToSection('services')} className="text-gray-800 font-medium hover:text-red-600 text-left whitespace-nowrap">
                Serviços
              </button>
              <button onClick={() => scrollToSection('partnerships')} className="text-gray-800 font-medium hover:text-red-600 text-left whitespace-nowrap">
                Amizades
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-800 font-medium hover:text-red-600 text-left whitespace-nowrap">
                Contato
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-red-600 to-red-500 text-white px-6 py-2 rounded-full font-semibold hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Fale Conosco
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
